// Support Page Component - ES5 Compatible
var SATELLAI_CMS_BASE = {
  dev: 'https://development-kxl9.onrender.com',
  prod: 'https://satellai-web.onrender.com'
};

// 根据当前主题名称判断 CMS 环境，避免 environment-config.js 未加载时拿不到接口地址
function getSupportPageCmsEnv() {
  var themeName = (window.__SHOPIFY_THEME_NAME__ || '').toLowerCase();
  return themeName === 'dev' || themeName === 'satellai/dev' || themeName === 'satellai-theme/dev' ? 'dev' : 'prod';
}

// 优先读取统一环境配置；如果加载顺序较早，则使用同一套 CMS 域名兜底
function buildSupportPageCmsApiUrl(configKey, path) {
  if (window.EnvironmentConfig && typeof window.EnvironmentConfig.getApiUrl === 'function') {
    var configuredUrl = window.EnvironmentConfig.getApiUrl(configKey);
    if (configuredUrl) {
      return configuredUrl;
    }
  }

  var env = getSupportPageCmsEnv();
  return SATELLAI_CMS_BASE[env] + path;
}

var SupportPageComponent = function() {
  function SupportPageComponent() {
    this.searchTimer = null;
    this.searchApiUrl = buildSupportPageCmsApiUrl('helpSearchApiUrl', '/api/v2/web/help/article/search');
    
    // FAQ 接口地址
    this.faqCollectionsApiUrl = buildSupportPageCmsApiUrl('faqCollectionsApiUrl', '/api/v2/web/faq/collections');
    this.faqArticlesApiUrl = buildSupportPageCmsApiUrl('faqArticlesApiUrl', '/api/v2/web/faq/articles');
    this.faqViewApiUrl = buildSupportPageCmsApiUrl('faqViewApiUrl', '/api/v2/web/faq/view');
    
    // 初始化空数据
    this.faqCategories = [];
    this.faqArticles = [];
  }
  
  // 获取 FAQ 分类列表
  SupportPageComponent.prototype.fetchFaqCollections = function() {
    var self = this;
    return fetch(self.faqCollectionsApiUrl)
      .then(function(response) {
        if (!response.ok) {
          throw new Error('获取分类失败');
        }
        return response.json();
      })
      .then(function(response) {
        // 检查响应格式并提取 collections 数据
        if (response && response.success && Array.isArray(response.collections)) {
          // 按 order 字段排序
          return response.collections.sort(function(a, b) {
            return a.order - b.order;
          });
        }
        return [];
      })
      .catch(function(error) {
        console.error('获取 FAQ 分类错误:', error);
        return [];
      });
  };
  
  // 获取 FAQ 文章列表
  SupportPageComponent.prototype.fetchFaqArticles = function() {
    var self = this;
    return fetch(self.faqArticlesApiUrl)
      .then(function(response) {
        if (!response.ok) {
          throw new Error('获取文章失败');
        }
        return response.json();
      })
      .then(function(response) {
        // 检查响应格式并提取文章数据
        if (response && response.success && Array.isArray(response.data)) {
          // 按 sortOrder 字段排序
          return response.data.sort(function(a, b) {
            return a.sortOrder - b.sortOrder;
          });
        }
        return [];
      })
      .catch(function(error) {
        console.error('获取 FAQ 文章错误:', error);
        return [];
      });
  };

  SupportPageComponent.prototype.init = function() {
    var self = this;
    
    return {
      // Data properties
      searchQuery: '',
      searchResults: [],
      searchLoading: false,
      showSearchDropdown: false,
      // FAQ 数据
      faqs: [],
      faqCategories: [],
      activeCategory: null,
      openFaqs: [],
      faqLoading: true,
      
      // 初始化方法 - 加载 FAQ 数据
      init: function() {
        var that = this;
        
        // 并行获取分类和文章数据
        Promise.all([
          self.fetchFaqCollections(),
          self.fetchFaqArticles()
        ]).then(function(results) {
          var collections = results[0];
          var articles = results[1];
          // 设置分类数据
          that.faqCategories = collections;
          
          // 转换文章数据格式以匹配原有结构
          that.faqs = articles.map(function(article) {
            return {
              id: article.id,
              question: article.title,
              answer: article.content,
              collection: article.collection
            };
          });
          // 设置默认激活的分类为第一个分类
          if (collections.length > 0) {
            that.activeCategory = collections[0].id;
          }
          
          that.faqLoading = false;
        }).catch(function(error) {
          console.error('初始化 FAQ 数据失败:', error);
          that.faqLoading = false;
        });
      },
      
      // Methods
      handleSearch: function() {
        var query = this.searchQuery.trim();
        var that = this;
        
        clearTimeout(self.searchTimer);
        
        if (query.length < 2) {
          this.searchResults = [];
          this.searchLoading = false;
          this.showSearchDropdown = false;
          return;
        }
        
        // 显示下拉框和 loading 状态
        this.showSearchDropdown = true;
        this.searchLoading = true;
        
        // 调用真实 API
        self.searchTimer = setTimeout(function() {
          fetch(self.searchApiUrl + '?q=' + encodeURIComponent(query))
            .then(function(response) {
              if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              return response.json();
            })
            .then(function(data) {
              that.searchResults = data.results || [];
              that.searchLoading = false;
            })
            .catch(function(error) {
              console.error('Search error:', error);
              that.searchResults = [];
              that.searchLoading = false;
            });
        }, 300);
      },
      
      selectSearchItem: function(item) {
        // 跳转到 help-center 页面并带上文章 ID
        window.location.href = '/pages/help-center?article=' + item.id;
      },
      
      handleSearchFocus: function() {
        if (this.searchQuery.trim().length >= 2) {
          this.showSearchDropdown = true;
        }
      },
      
      hideSearchDropdown: function() {
        var that = this;
        // Delay to allow click on dropdown items
        setTimeout(function() {
          that.showSearchDropdown = false;
        }, 200);
      },
      
      toggleFaq: function(faqId) {
        var index = this.openFaqs.indexOf(faqId);
        if (index > -1) {
          // 收缩时不调用接口
          this.openFaqs.splice(index, 1);
        } else {
          // 展开时调用浏览量更新接口
          this.openFaqs.push(faqId);
          this.updateFaqView(faqId);
        }
      },
      
      // 更新 FAQ 浏览量
      updateFaqView: function(articleId) {
        var xhr = new XMLHttpRequest();
        var url = self.faqViewApiUrl;
        
        // 创建 FormData 对象
        var formData = new FormData();
        formData.append('articleId', articleId);
        
        // 配置请求
        xhr.open('POST', url, true);
        
        // 设置响应处理
        xhr.onload = function() {
          if (xhr.status === 200) {
            try {
              var response = JSON.parse(xhr.responseText);
              if (response.success) {
                console.log('浏览量已更新:', response.view);
              }
            } catch (error) {
              console.error('解析响应失败:', error);
            }
          } else {
            console.error('请求失败，状态码:', xhr.status);
          }
        };
        
        xhr.onerror = function() {
          console.error('请求失败');
        };
        
        // 发送请求
        xhr.send(formData);
      },
      
      get filteredFaqs() {
        var categoryId = this.activeCategory;
        // 所有设备都按分类过滤
        return this.faqs.filter(function(faq) {
          return faq.collection === categoryId;
        });
      }
    };
  };
  
  return SupportPageComponent;
}();

// Register Alpine component
document.addEventListener('alpine:init', function() {
  Alpine.data('supportPage', function() {
    return new SupportPageComponent().init();
  });
});
